import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SignInModel } from '../model/af.model';
import { AuthService } from '../service/auth.service';
import { EventService } from '../service/event.service';
import { ShowErrorEvent } from '../service/events';

interface ChangePassowrdFormModel {
  oldPassword: FormControl<string>,
  newPassword: FormControl<string>,
  confirmPassword: FormControl<string>
}

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  standalone: false
})
export class ChangePasswordComponent implements OnInit {

  showPasswordHint: boolean = false;
  showReEnterPasswordHint: boolean = false;
  user: any;
  hide: boolean = true;
  formModel: SignInModel;
  showError: boolean = false;
  login_vendor: number = 4;
  loginType: number;
  email: string;
  changePasswordGroup: UntypedFormGroup;

  constructor(private router: Router, private fb: FormBuilder, private userService: AuthService, private eventBus: EventService) {
    this.loginType = Number(localStorage.getItem('loginType'));
    if (this.loginType == 4) {
      this.user = this.userService.getVendorUser();
      this.email = this.user.username;
    } else {
      this.user = this.userService.getUser();
      this.email = this.user.email;
    }

    if (!this.user) {
      this.invalid();
    }
  }

  ngOnInit(): void {
    this.createGroup();
  }

  createGroup(): void {
    this.changePasswordGroup = this.fb.group<ChangePassowrdFormModel>({
      oldPassword: this.fb.control('', [Validators.required, Validators.minLength(8), Validators.maxLength(20)]),
      newPassword: this.fb.control('', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern('(?:[0-9]+[a-z A-Z]|[a-z A-Z]+[0-9])[a-z A-Z 0-9]*')]),
      confirmPassword: this.fb.control('', [Validators.required])
    }, {
      validators: [passwordValidator()]
    });
  }

  get oldPassword() { return this.changePasswordGroup.get('oldPassword') }
  get newPassword() { return this.changePasswordGroup.get('newPassword') }
  get confirmPassword() { return this.changePasswordGroup.get('confirmPassword') }

  checkSpecialCharacters(str: string) {
    const regex = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/g;
    return !regex.test(str);
  }
  checkAlphaCharacter(str: string) {
    const regex = /[a-zA-Z]/;
    return regex.test(str);
  }
  checkNumeric(str: string) {
    const regex = /\d/;
    return regex.test(str);
  }

  showHint() {
    this.showPasswordHint = !this.showPasswordHint;
  }

  showHintTwo() {
    this.showReEnterPasswordHint = !this.showReEnterPasswordHint;
  }

  invalid() {
    this.router.navigate(['unauthorized']);
  }

  navigateLogin() {
    this.router.navigate(['login']);
  }

  generatePassword() {
    let i: number;
    let randPass: string;
    let loop: boolean = false;
    let values: Uint32Array;
    const charSet: string = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    const keywords = /(APPL|ASDF|BASIC|CADAM|DEMO|FOCUS|GAME|IBM|LOG|NATION|NCNB|NET|NEW|MONEY|RESET|ROS|SIGN|SOVRAN|SYS|TEST|TSO|VALID|VTAM|XXX|1234|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)/i;

    do {
      randPass = "";
      values = new Uint32Array(8);
      window.crypto.getRandomValues(values);

      for (i = 0; i < 8; ++i) {
        randPass += charSet[values[i] % charSet.length];
      }

      const alphaNumRegex = /^(?=.*[a-zA-Z])(?=.*\d)/;
      if (alphaNumRegex.exec(randPass) && !keywords.exec(randPass)) {
        this.changePasswordGroup.get('newPassword').setValue(randPass);
        loop = false;
      } else {
        loop = true;
      }
    } while (loop);
  }

  onSubmit() {
    let signInModel = new SignInModel();
    const loginType = Number(localStorage.getItem('loginType'));
    signInModel.verifyId = this.userService.getVerifyId();

    if (this.loginType === 4) {
      signInModel.username = this.user.username;
    } else {
      signInModel.username = this.user.email;
    }

    signInModel.password = this.oldPassword.value;
    signInModel.newPassword = this.newPassword.value;
    signInModel.confirmNewPassword = this.confirmPassword.value;
    signInModel.vendorSign = (loginType == 4);

    let observable: Observable<SignInModel>;
    if (loginType == 4) {
      observable = this.userService.updateVendorPassword(signInModel);
    } else {
      observable = this.userService.updatePassword(signInModel);
    }


    observable.subscribe({
      next: (data: SignInModel) => {
        if (data) {
          this.formModel = data;
          if (!data.errorMessage && !data.warningMessage) {
            this.router.navigate(['login']);
          } else if (data.errorMessage) {
            this.eventBus.emit(new ShowErrorEvent({ httpStatus: 1, text: data.errorMessage }));
            this.showError = !!data.errorMessage;
          }
        }
      },
      error: (error: any) => console.log(error)
    });
  }
}

export function passwordValidator(): ValidatorFn {
  return (control: UntypedFormGroup): ValidationErrors | null => {
    const errors: ValidationErrors = {};
    const newPasswordControl = control.get('newPassword');
    const confirmPasswordControl = control.get('confirmPassword');

    if (newPasswordControl.value && confirmPasswordControl.value && (newPasswordControl.value != confirmPasswordControl.value)) {
      confirmPasswordControl.setErrors({ noMatch: true });
    }

    return Object.keys(errors).length ? errors : null;
  };
}
